export default __webpack_public_path__ + "static/media/portfolio-156.f93076fb.jpg";